import type { ReadonlyDeep } from 'type-fest';

import { AmountInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import type { CostForm_FixedCost_Amount } from '../fragments/fixed-cost.fragment';

export function amountForm2ApiMapper(
  amount: ReadonlyDeep<CostForm_FixedCost_Amount>,
): ReadonlyDeep<AmountInput> {
  const amountInput = pruneInput(amount, AmountInput);

  return amountInput;
}
